import { BusinessUnitServiceBase } from './business-unit.service.base';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { BusinessUnit } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BusinessUnitService extends BusinessUnitServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  findAll(restricted: boolean = true, reduced?: boolean): Observable<HateoasMultipleResponseObject<BusinessUnit>> {
    var params = new HttpParams();
    params = appendSerialisedHttpParams(restricted, 'restricted', params);
    params = appendSerialisedHttpParams(reduced, 'reduced', params);
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<BusinessUnit>>(this.getUrlBaseFindAll(), {
      params: params
    }));
  }


  findActive(restricted: boolean = true, reduced?: boolean): Observable<HateoasMultipleResponseObject<BusinessUnit>> {
    var params = new HttpParams();
    params = appendSerialisedHttpParams(restricted, 'restricted', params);
    params = appendSerialisedHttpParams(reduced, 'reduced', params);
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<BusinessUnit>>(this.serviceBaseUrl + '/active', {
      params: params
    }));
  }

}



